import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import DateUtils from '../utils/date';
import withTheme from '../theme/withTheme';
import { useViews } from './hooks/userViews';
import { useOptions } from './hooks/useOptions';
import { useCalendarState } from './hooks/useCalendarState';
import DateSelection from './CalendarDate';
import YearSelection from './CalendarYear';
import MonthSelection from './CalendarMonth';
import CalendarToolbar from './CalendarToolbar';
import { ViewContainer, CalendarWrapper } from './styles';
var utils = new DateUtils();
var Calendar = function Calendar(props) {
  var views = props.views,
    disableToolbar = props.disableToolbar,
    disablePast = props.disablePast,
    disableFuture = props.disableFuture,
    onChange = props.onChange,
    openTo = props.openTo,
    unparsedMinDate = props.minDate,
    unparsedMaxDate = props.maxDate,
    animateYearScrolling = props.animateYearScrolling,
    leftArrowIcon = props.leftArrowIcon,
    rightArrowIcon = props.rightArrowIcon,
    renderDay = props.renderDay,
    shouldDisableDate = props.shouldDisableDate,
    allowKeyboardControl = props.allowKeyboardControl,
    onMonthChange = props.onMonthChange,
    onYearChange = props.onYearChange,
    loadingIndicator = props.loadingIndicator,
    theme = props.theme;
  var options = useOptions(props);
  var _useCalendarState = useCalendarState(props, options),
    calendarProps = _useCalendarState.calendarProps;
  var _useViews = useViews(views, openTo, onChange),
    openView = _useViews.openView,
    setOpenView = _useViews.setOpenView,
    handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;
  var minDate = utils.date(unparsedMinDate);
  var maxDate = utils.date(unparsedMaxDate);
  return /*#__PURE__*/React.createElement(CalendarWrapper, {
    theme: theme
  }, !disableToolbar && /*#__PURE__*/React.createElement(CalendarToolbar, _extends({
    setOpenView: setOpenView,
    openView: openView
  }, calendarProps, props)), /*#__PURE__*/React.createElement(ViewContainer, {
    theme: theme
  }, openView === 'year' && /*#__PURE__*/React.createElement(YearSelection, {
    date: calendarProps.date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate,
    disablePast: disablePast,
    disableFuture: disableFuture,
    onYearChange: onYearChange,
    animateYearScrolling: animateYearScrolling
  }), openView === 'month' && /*#__PURE__*/React.createElement(MonthSelection, {
    date: calendarProps.date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate,
    disablePast: disablePast,
    disableFuture: disableFuture,
    onMonthChange: onMonthChange
  }), openView === 'date' && /*#__PURE__*/React.createElement(DateSelection, {
    date: calendarProps.date,
    onChange: handleChangeAndOpenNext,
    onMonthChange: onMonthChange,
    disablePast: disablePast,
    disableFuture: disableFuture,
    minDate: minDate,
    maxDate: maxDate,
    leftArrowIcon: leftArrowIcon,
    rightArrowIcon: rightArrowIcon,
    renderDay: renderDay,
    shouldDisableDate: shouldDisableDate,
    allowKeyboardControl: allowKeyboardControl,
    loadingIndicator: loadingIndicator
  })));
};
process.env.NODE_ENV !== "production" ? Calendar.propTypes = {
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  invalidDateMessage: PropTypes.string,
  minDateMessage: PropTypes.string,
  maxDateMessage: PropTypes.string,
  allowKeyboardControl: PropTypes.bool,
  disableToolbar: PropTypes.bool,
  views: PropTypes.arrayOf(PropTypes.string),
  openTo: PropTypes.oneOf(['date', 'month', 'year'])
} : void 0;
Calendar.defaultProps = {
  minDate: new Date('1900-01-01'),
  maxDate: new Date('2100-01-01'),
  invalidDateMessage: 'Formato inválido',
  minDateMessage: 'Data menor que a data mínima',
  maxDateMessage: 'Data maior que a data máxima',
  allowKeyboardControl: true,
  disableToolbar: false,
  views: ['year', 'date'],
  openTo: 'date'
};
export default withTheme(Calendar);